import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Card, List, Dropdown, Menu, Modal, Button, Typography } from 'antd';
import {
  ExclamationCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from '@ant-design/icons';

import styles from './VehicleItem.module.css';

import noImage from '../../assets/img/no-image.png';
import gearshift from '../../assets/img/icons/gearshift.png';
import engine from '../../assets/img/icons/engine.png';
import fuel from '../../assets/img/icons/fuel.png';

const VehicleItem = ({ vehicle, onDeleteVehicle, onEditVehicle }) => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const { confirm } = Modal;
  const loggedInUser = useSelector((state) => state.auth.loggedInUser);
  const showConfirm = () => {
    confirm({
      title: t('vehicles.deleteVehicleConfirmationText', {
  make: vehicle.vehicleMake.name,
  model: vehicle.vehicleModel.name
}),
      icon: <ExclamationCircleOutlined />,
      okType: 'danger',
      maskClosable: 'true',
      onOk() {
        onDeleteVehicle(vehicle.id);
      },
      onCancel() {},
    });
  };

  const navigateToVeichle = () => {
    navigate(`${vehicle.id}`);
  };

  const items = [
    {
      label: t('form.vehicleForm.editButton'),
      key: 'edit',
      icon: <EditOutlined />,
      onClick: () => {
        onEditVehicle(vehicle);
      },
    },
    {
      label: t('vehicles.deleteVehicle'),
      key: 'delete',
      danger: true,
      icon: <DeleteOutlined />,
      onClick: () => {
        showConfirm();
      },
    },
  ];

  return (
    <List.Item>
      <Card
        style={{
          boxShadow: 'rgb(178 213 198 / 56%) 2px 4px 8px 2px',
          borderRadius: '8px',
        }}
        headStyle={{ borderBottom: 'none', color: 'var(--ant-primary-8)' }}
        bodyStyle={{ padding: '15px' }}
        cover={
          <img
            alt="example"
            src={
              vehicle.images && vehicle.images.length > 0
                ? vehicle.images[0].path
                : noImage
            }
            className={`${styles.coverImage}`}
            onClick={navigateToVeichle}
            loading="lazy"
            style={{
              height: '200px',
              filter: 'blur(5px)',
            }}
            onLoad={(e) => {
              e.target.style.height = '100%';
              e.target.style.filter = 'none';
            }}
          />
        }
      >
        {!(
          loggedInUser.role.name === 'user' ||
          loggedInUser.role.name === 'carHouseAdmin'
        ) && (
          <Dropdown.Button
            style={{
              position: 'absolute',
              right: '10px',
              top: '3px',
              zIndex: '3',
            }}
            overlay={<Menu mode="vertical" items={items} />}
          ></Dropdown.Button>
        )}

        <h3>
          {vehicle.vehicleMake.name} {vehicle.vehicleModel.name}{' '}
          {vehicle.modelYear && `(${vehicle?.modelYear})`}
        </h3>
        <ul className={`${styles.customList}`}>
          <li>
            <img
              className={`${styles.customListImage}`}
              src={fuel}
              alt="fuel"
            ></img>
            {vehicle.fuelType}
          </li>
          <li>
            <img
              className={`${styles.customListImage}`}
              src={engine}
              alt="engine"
            ></img>
            {vehicle.engineSize}
          </li>
          <li>
            <img
              className={`${styles.customListImage}`}
              src={gearshift}
              alt="engine"
            ></img>
            {vehicle.gearbox}
          </li>
        </ul>

        {(loggedInUser.role.name === 'carHouseAdmin' ||
          loggedInUser.role.name === 'root') &&
          vehicle.users &&
          vehicle.users.length > 0 && (
            <div style={{ marginTop: 16, marginBottom: 16 }}>
              <h4 style={{ marginBottom: 8 }}>{t('vehicles.buyers')}: </h4>
              <List
                size="small"
                bordered
                dataSource={vehicle.users}
                renderItem={(buyer) => (
                  <List.Item>
                    <Typography.Text strong>
                      {buyer.firstName} {buyer.lastName}
                    </Typography.Text>{' '}
                    ({buyer.role.name === 'carHouseAdmin' ? t('roles.admin') : t('roles.user')})
                  </List.Item>
                )}
              />
            </div>
          )}

        <Button
          block
          type="primary"
          icon={<EyeOutlined />}
          onClick={navigateToVeichle}
        >
          {t('vehicles.details')}
        </Button>
      </Card>
    </List.Item>
  );
};

export default VehicleItem;
